// @flow
import styled from 'styled-components'
import theme from '../../../../styles/theme'

export const Wrapper = styled.div`
  border: ${theme.borderDefault};
  padding: 16px;
`

export const TitleBox = styled.h4`
  margin: 0px;
  line-height: 2.95rem;
  padding: 0 1.2rem;
  font-size: ${theme.headingCheckout};
  font-family: ${theme.brandFontFamily};
  font-weight: 400;
  text-align: center;
  border-top: ${theme.borderDefault};
  border-left: ${theme.borderDefault};
  border-right: ${theme.borderDefault};
`

export default {
  container: {
    border: '1px solid #000',
    padding: 24
  },
  addressCardMargin: {
    marginBottom: 8
  },
  link: {
    display: 'inline-block',
    margin: '16px 2px 27px',
    color: '#000000'
  }
}
